import {
  red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal, green,
  lightGreen, lime, yellow, amber, orange, deepOrange, brown, grey, blueGrey
} from '@mui/material/colors';

const washedOutColors = [
  red[200], pink[200], purple[200], deepPurple[200], indigo[200], blue[300],
  lightBlue[300], cyan[300], teal[200], green[300], lightGreen[400], lime[500],
  yellow[600], amber[400], orange[400], deepOrange[300], brown[200], grey[400],
  blueGrey[200]
];

/**
 * Generates a consistent color from the palette based on a string (e.g., user ID).
 * @param {string} id The input string.
 * @returns {string} A color string (hex).
 */
export const getColorFromString = (id) => {
  if (!id || id.length === 0) {
    return grey[400]; // Default color
  }
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
    // eslint-disable-next-line no-bitwise
    hash &= hash; // Convert to 32bit integer
  }
  const index = Math.abs(hash) % washedOutColors.length;
  return washedOutColors[index];
}; 